import { normalize } from 'normalizr';

import {
  NormalizeMultiTenantOrganization,
  PreNormalizedMultiTenantOrganizationEntities,
} from './normalizeMultiTenantOrganization.types';
import { multiTenantNetworkSchema } from './schemas/multiTenantOrganization';

export const normalizeMultiTenantOrganization: NormalizeMultiTenantOrganization = (response) => {
  const { multiTenantOrganization } = response.data;

  if (multiTenantOrganization == null) {
    return null;
  }

  const { entities: normalizedMultiTenantEntities, result } = normalize<
    unknown,
    PreNormalizedMultiTenantOrganizationEntities
  >(multiTenantOrganization, multiTenantNetworkSchema);

  return {
    entities: {
      multiTenantOrganization: normalizedMultiTenantEntities.multiTenantOrganization[result],
      networks: normalizedMultiTenantEntities.networks,
    },
    result,
  };
};
